<template>
   <card class="card-user" style="margin: -30px; height: 100vh;">

    <!-- <div class="card-body">
      <div class="iframe-container">
        <iframe :src="system.urlIframe" frameborder="0" ></iframe>
      </div>
    </div> -->

    <div v-if="showConfirmModal" class="modal-overlay">
    <div class="modalito">
      <h3 style="color: #003f8a;">¿Está seguro de que desea cerrar esta pestaña?</h3>

      <p>Al cerrar, se perderán los cambios no guardados.</p>
      <button @click="closeConfirmed">Sí</button>
      <button @click="closeCancelled">No</button>
    </div>
  </div>


    <div class="card-body">
  <div class="tabs" >
    <ul id="tabs-nav" class="tabs-nav" >
      <li v-for="(tab, index) in tabs" :key="tab.id" :class="{'active': tab.active}">
        <button @click="selectTab(tab.id)">
          {{index+1}}. {{ tab.nombre }}
          <span class="close-tab" @click.stop="closeTab(tab.id)">×</span>
        </button>
      </li>
    </ul>
    <div id="tabs-content" class="tabs-content">
      <div v-for="tab in tabs" :key="tab.id" v-if="tab.active">
        <iframe :key="tab.id" :src="tab.urlIframe" frameborder="0" style="width: 100%; height: 100vh;"></iframe>
      </div>
    </div>
  </div>
</div>

  </card> 

  <!-- <card class="card-user" style="margin: -30px; height: 100vh;">
    <div class="card-body">
      <div class="tabs">
        <ul id="tabs-nav">
          <li v-for="(tab, index) in tabs" :key="tab.id" :class="{'active': tab.active}">
            <button @click="selectTab(tab.id)">
              {{ tab.nombre }}
              <span class="close-tab" @click.stop="closeTab(tab.id)">×</span>
            </button>
          </li>
        </ul>
        <div id="tabs-content">
          <div v-for="tab in tabs" :key="tab.id" v-show="tab.active" class="tab-content">
            <iframe :src="tab.urlIframe" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </card> -->



</template>
<script>

import MainService from "@/services/MainService.js";

export default {
  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  name: "PersonaPage",
  data() {
    return {
      ss: new MainService(),
      rutaApp:process.env.VUE_APP_RRHH_SERVICE,

      auth:{},
      persona:{},
      system:{},
      tabs: [],
      showConfirmModal:false,
      details: [
        {
          title: "12",
          subTitle: "Files",
        },
        {
          title: "2GB",
          subTitle: "Used",
        },
        {
          title: "24,6$",
          subTitle: "Spent",
        },
      ],

     
    };
  },
  methods: {

    selectTab(tabId) {
      // Verificar si ya hay un tab activo
      const activeTab = this.tabs.find(tab => tab.active === true);

      // Si ya existe un tab activo, lo desactivamos
      if (activeTab) {
        activeTab.active = false;
      }

      // Ahora activamos el tab seleccionado
      const selectedTab = this.tabs.find(tab => tab.id === tabId);
      if (selectedTab) {
        selectedTab.active = true;
      }
      
    },

    // Agrega una nueva pestaña
    addTab(system) {

      if(this.auth.email === undefined && this.auth.CI === undefined){
        return;
      }

      // Verificar si el sistema ya está en los tabs por su nombre o URL
      const tabExists = this.tabs.some(tab => tab.nombre === system.Nombre || tab.urlIframe === `${system.URL}?email=${this.auth.email}&password=${this.auth.CI}`);
      
      // Si ya existe, no agregar el nuevo tab
      if (tabExists) {
          console.log("El sistema ya está abierto.");
          return; // Salir de la función para no agregar el sistema
      }

      // Si no existe, agregar el nuevo tab
      const newTab = {
          id: `tab-${this.tabs.length + 1}`,
          nombre: system.Nombre,
          urlIframe: `${system.URL}?email=${this.auth.email}&password=${this.auth.CI}`,
          active: true // La nueva pestaña será la activa
      };
      this.tabs.push(newTab);

      this.tabs.forEach(tab => {
      if (tab.id !== newTab.id) {
        tab.active = false;
      }

      console.log(this.tabs);

    });

      this.selectTab(newTab.id);
    },
    openConfirmModal(tabId) {
      this.showConfirmModal = true;
      this.tabToClose = tabId;
    },

    closeConfirmed() {
      const index = this.tabs.findIndex(tab => tab.id === this.tabToClose);
      if (index !== -1) {
        this.tabs.splice(index, 1);  // Eliminar la pestaña
        // Si la pestaña cerrada era la activa, seleccionar la siguiente
        if (this.tabs.length > 0) {
          this.selectTab(this.tabs[0].id);  // Activar la primera pestaña
        }
      }
      this.showConfirmModal = false;
      console.log(this.tabs);
    },

    closeCancelled() {
      this.showConfirmModal = false; // Cerrar el modal sin hacer nada
    },
    // Cierra una pestaña
    closeTab(tabId) {

      this.openConfirmModal(tabId);
      
    },

    // Función que actualiza la información del sistema cuando cambia la consulta
    updateSystemFromQuery(newQuery) {
      const { id, Nombre, URL } = newQuery;
    
      if (id && id !== this.system.id) {
        this.system.id = id;
        this.system.Nombre = Nombre || '';
        this.system.URL = URL || '';

        // Llamar a la función que agrega una nueva pestaña
        this.addTab(this.system);
      }
    },


    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-lg-3 offset-lg-1";
      } else if (remainder === 2) {
        return "col-lg-4";
      } else {
        return "col-lg-3";
      }
    },

    showPersona() {
      console.log("show");
            
            this.ss.showPersona(this.auth.id).then(
                (result) => {
                    let response = result.data;
                    this.persona = response.data;
                    console.log(this.persona);

                    // this.$refs['view-usuario'].show();
                    // this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
    },

    print(){
      console.log("hola");
    },
    updateSystemFromQuery(newQuery) {
      const { id, Nombre, URL } = newQuery;
    
      // Solo refrescar si hay un nuevo sistema seleccionado
      if (id && id !== this.system.id) {
        this.system.id = id;
        this.system.Nombre = Nombre || '';
        this.system.URL = URL || '';

        this.system.urlIframe = this.system.URL + '?email=' + this.auth.email + '&password=' + this.auth.CI;
        //this.system.urlIframe = this.system.URL;
        this.addTab(this.system);
        //console.log("Updated system:", this.system);
        // Aquí puedes agregar lógica adicional si es necesario
        this.$forceUpdate();
      }
    },
  },


  watch: {
    '$route.query': {
      handler(newQuery) {
        this.updateSystemFromQuery(newQuery);
        
      },
      immediate: true // Para que también se ejecute al cargar el componente
    }
  },

   mounted() {

        this.system.id = this.$route.query.id;
        this.system.Nombre = this.$route.query.Nombre;
        this.system.URL = this.$route.query.URL;
        console.log(this.system);

        this.auth = JSON.parse(localStorage.getItem('usuario'));
        console.log("persona autenticada card",this.auth);
        if (!this.auth) {
            this.$router.push('/Login');
        } else {
            
            //this.showPersona();
            // this.print();
            
        }
    }
};
</script>
<style>


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos del cuadro del modal */
.modalito {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.modalito button {
  margin: 10px;
  padding: 10px 20px;
  border: none;
  background-color: #003f8a;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
}

.modalito button:hover {
  background-color: #002b5c;
}


/* Aseguramos que la tarjeta ocupa el 100% de la pantalla */
.card-user {
  height: 100vh;  /* Ocupa toda la altura de la ventana */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.card-body {
  flex: 1;   /* Ocupa todo el espacio restante */
  display: flex; /* Usamos flexbox para distribuir el espacio */
  flex-direction: column; /* Asegura que los elementos se acomoden verticalmente */
  padding: 0;  /* Elimina el padding para aprovechar todo el espacio */
  margin: 0;   /* Elimina márgenes que puedan afectar el tamaño */
}
/* Aseguramos que el iframe se expanda dentro del contenedor */
.iframe-container {
  flex: 1;  /* Hace que este contenedor ocupe todo el espacio dentro del .card-body */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.tabs {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.tabs-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  border-bottom: 2px solid #ddd;
}

.tabs-nav li {
  margin-right: 10px;
  width: 150px;
  display: inline-block;
}

.tabs-nav li button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  padding: 0px;
  text-align: center;
  color: #003f8a;
  border-right: 2px solid #ddd;
  width: 150px;

}

.tabs-nav li button:hover {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  padding: 0px;
  text-align: center;
  color: #003f8a;
  font-weight: bold;
  border-right: 2px solid #ddd;
  width: 150px;

}


.tabs-nav li.active button {
  font-weight: bold;
  background: #003e8a37;
  border-bottom: 2px solid #003f8a; /* Resalta la pestaña activa */
  border-right: 2px solid #ddd;
  width: 150px;

}

.close-tab {
  margin-left: 10px;
  cursor: pointer;
  color: #ff0000;
  font-weight: bold;
}

.tabs-content {
  padding: 20px 0;
  flex: 1;
}

.tab-content {
  display: none; /* Ocultar contenido por defecto */
  flex: 1;
}

.tab-content iframe {
  width: 100%;
  height: 100%; /* Ajusta el tamaño del iframe según lo necesites */
  border: none;
  flex: 1;
}

.tab-content.active {
  display: block; /* Mostrar solo el contenido activo */
  flex: 1;
}

</style>